import { z } from 'zod';
export const KnowledgeFileStatus = z.enum(['pending', 'processing', 'ready', 'failed']);
export const KnowledgeFileDTO = z.object({
    id: z.string().uuid(),
    websiteId: z.string().uuid(),
    filename: z.string(),
    mime: z.string(),
    size: z.number().int().nonnegative(),
    status: KnowledgeFileStatus,
    error: z.string().nullable(),
    chunkCount: z.number().int().nonnegative().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=knowledge.js.map